import { render } from "./SideSliderComponent.vue?vue&type=template&id=12cff80b&ts=true"
import script from "./SideSliderComponent.vue?vue&type=script&lang=ts"
export * from "./SideSliderComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__